import React from 'react';
import Section from '@hero/ui-kit/layout/Section';
import H from '@hero/ui-kit/typography/H';
import P from '@hero/ui-kit/typography/P';
import useTheme from '@hero/branding/theme';
import SegmentBuilder from './SegmentBuilder';
const NewSegment: React.FC = () => {
    const { colors } = useTheme();
    return (
        <Section noDefaultPadding>
            <H
                role="h4"
                styles={{
                    marginBottom: '0.8rem'
                }}
            >
                New segment
            </H>
            <P
                styles={{
                    color: colors.neutrals.textBeta,
                    marginBottom: '2.4rem'
                }}
            >
                Build an audience you can reuse in blasts and drips.
            </P>
            <SegmentBuilder mode="create" />
        </Section>
    );
};
export default NewSegment;
